import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";
import { ApiConnectionString } from "../../constants/ApiConntection";
import "./ResetPasswordPage.css";

const logo = "/logo192.png";

export default function ResetPasswordPage() {
  const { token } = useParams();

  const [checking, setChecking] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    checkToken();
  }, [token]);

  const checkToken = async () => {
    try {
      setChecking(true);
      setError("");

      const res = await axios.get(
        `${ApiConnectionString}/api/therapist/ForgotPassword/${token}`
      );

      setTokenValid(res.data === true || res.data === "true");
    } catch (err) {
      if (typeof err.response?.data === "string") {
        setError(err.response.data);
      } else {
        setError("This password reset link is invalid or has expired.");
      }

      setTokenValid(false);
    } finally {
      setChecking(false);
    }
  };

  const resetPassword = async (e) => {
    e.preventDefault();

    setError("");

    if (!password || !confirmPassword) {
      setError("Please complete both password fields.");
      return;
    }

    if (password.length < 6) {
      setError("Your new password must be at least 6 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setError("The passwords do not match.");
      return;
    }

    try {
      setSaving(true);

      await axios.put(
        `${ApiConnectionString}/api/therapist/ForgotPassword/resetpassword`,
        {
          token,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setComplete(true);
    } catch (err) {
      if (err.response?.data === "expired") {
        setError("This password reset link has expired.");
      } else if (typeof err.response?.data === "string") {
        setError(err.response.data);
      } else {
        setError("Could not reset your password.");
      }
    } finally {
      setSaving(false);
    }
  };

  if (checking) {
    return (
      <div className="reset-loading">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="reset-page">
      <div className="reset-card brand-card">
        <div className="login-brand">
          <div className="login-logo">
            <img src={logo} alt="Therapy Diary App logo" />
          </div>

          <div>
            <h1>Therapy Diary App</h1>
            <p>Password reset</p>
          </div>
        </div>

        {complete ? (
          <>
            <div className="reset-heading">
              <h2>Password changed</h2>
              <p>Your password has been reset. You can now log in.</p>
            </div>

            <Link to="/login" className="btn brand-btn w-100 mt-3">
              Back to login
            </Link>
          </>
        ) : !tokenValid ? (
          <>
            <div className="reset-heading">
              <h2>Reset link unavailable</h2>
              <p>
                {error ||
                  "This password reset link is invalid or has expired."}
              </p>
            </div>

            <Link to="/login" className="btn brand-btn w-100 mt-3">
              Back to login
            </Link>
          </>
        ) : (
          <>
            <div className="reset-heading">
              <h2>Reset password</h2>
              <p>Enter your new password below.</p>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={resetPassword}>
              <div className="mb-3 login-password">
                <label className="form-label">New password</label>

                <div className="login-password-wrap">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Enter new password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />

                  <button
                    type="button"
                    className="login-show-btn"
                    onClick={() => setShowPassword((x) => !x)}
                  >
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
              </div>

              <div className="mb-3 login-password">
                <label className="form-label">Confirm new password</label>

                <div className="login-password-wrap">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />

                  <button
                    type="button"
                    className="login-show-btn"
                    onClick={() => setShowConfirmPassword((x) => !x)}
                  >
                    {showConfirmPassword ? "Hide" : "Show"}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="btn brand-btn w-100 mt-4"
                disabled={saving}
              >
                {saving ? "Saving..." : "Reset password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}